module.exports = __webpack_public_path__ + "img/flat_war3.2e6ce8ee.jpg";